<template>
    <transition>
        <div>
            <el-form :model="formData" :rules="formRules" ref="formRef" @submit.native.prevent>
                <div class="inline-form">
                    <el-form-item prop="firstName" class="inline-form-item">
                        <el-input v-model="formData.firstName" :placeholder="$t('first_name')"></el-input>
                    </el-form-item>
                    <el-form-item prop="lastName" class="inline-form-item">
                        <el-input v-model="formData.lastName" :placeholder="$t('last_name')"></el-input>
                    </el-form-item>
                </div>
                <el-form-item prop="account">
                    <el-input
                        v-model.number="formData.account"
                        :placeholder="$t('mobile')"
                        type="number"
                    >
                        <el-select
                            v-model="formData.code"
                            placeholder="code"
                            slot="prepend"
                            class="input-with-select"
                            filterable
                        >
                            <el-option
                                v-for="item in $store.getters.countryList"
                                :key="item.country_id"
                                :label="'+' + item.code"
                                :value="'+' + item.code"
                            >
                                <span style="float: left;color: #484848;">{{item.name}}</span>
                                <span style="float: right;color: #767676;">{{`+${item.code}`}}</span>
                            </el-option>
                        </el-select>
                    </el-input>
                </el-form-item>
                <el-form-item prop="vCode">
                    <el-input
                        v-model.number="formData.vCode"
                        :placeholder="$t('captcha')"
                        auto-complete="off"
                    >
                        <button
                            slot="append"
                            class="send-btn"
                            :class="{'send-btn-active': !sending}"
                            @click.stop="send"
                        >{{this.sending ? `Resend(${timer/1000}s)` : 'Send'}}</button>
                    </el-input>
                </el-form-item>

                <input type="text" style="display:none;" />
                <input type="password" style="display:none;" />

                <el-form-item prop="password">
                    <el-input
                        v-model="formData.password"
                        :placeholder="$t('login_password_as')"
                        :type="formData.type"
                    >
                        <i
                            class="iconfont show-pass-icon"
                            :class="[formData.type === 'password' ? 'icon-icon_visiblex' : 'icon-icon_invisiblex']"
                            slot="suffix"
                            @click="toggleShowPasswd(formData)"
                        ></i>
                    </el-input>
                </el-form-item>
                <p class="term-tips">
                    {{$t('joinTips')}}
                    <span class="spec-text" @click="termsUse">{{$t('termsUse')}}</span>
                    , {{$t('and')}}
                    <span
                        class="spec-text"
                        @click="policy"
                    >{{$t('privacy_policy')}}</span>
                </p>
                <button class="form-btn mobile-btn" @click="confirm">{{$t('confirm')}}</button>
            </el-form>
        </div>
    </transition>
</template>

<script>
import { signupGtag } from "@/lib/gtag.js";

export default {
    data() {
        return {
            formData: {
                firstName: "",
                lastName: "",
                account: "",
                code: `+${this.$store.getters.country.code || 86}`,
                vCode: "",
                password: "",
                type: "password"
            },
            formRules: {
                firstName: [
                    {
                        required: true,
                        message: this.$t("first_name_error"),
                        trigger: "none"
                    }
                ],
                lastName: [
                    {
                        required: true,
                        message: this.$t("last_name_error"),
                        trigger: "none"
                    }
                ],
                account: [
                    {
                        required: true,
                        message: this.$t("mobile_error"),
                        trigger: "none"
                    },
                    {
                        type: "number",
                        message: this.$t("mobile_error"),
                        trigger: "none"
                    }
                ],
                vCode: [
                    {
                        required: true,
                        message: this.$t("vcode_error"),
                        trigger: "none"
                    }
                ],
                password: [
                    {
                        required: true,
                        message: this.$t("reinput_passwd"),
                        trigger: "none"
                    }
                ]
            },
            sending: false,
            clockId: null,
            timer: 45000
        };
    },
    methods: {
        send() {
            const delay = 1000;
            if (!this.formData.account) {
                // this.$message('手机号不能为空', 'error');
                return;
            }
            if (!this.clockId) {
                this.sending = true;
                this.sendCode();
                this.clockId = setInterval(() => {
                    if (this.timer === 0) {
                        this.sending = false;
                        this.timer = 45000;
                        clearInterval(this.clockId);
                        this.clockId = null;
                    } else {
                        this.timer = this.timer - 1000;
                    }
                }, delay);
            }
        },
        sendCode() {
            this.$req
                .post("regsend", {
                    area_code: this.formData.code,
                    mobile: this.formData.account
                })
                .then(({ data }) => {
                    if (data.code === "2000") {
                        this.$msg.success(this.$t("msg_send"));
                    } else {
                        this.$msg.error(data.msg);
                        clearInterval(this.clockId);
                        this.clockId = null;
                        this.sending = false;
                        this.timer = 45000;
                    }
                });
        },
        confirm() {
            this.$refs["formRef"].validate(valid => {
                if (!valid) {
                    // this.$message('请检查您的表单', 'error')
                    return;
                }
                this.$req
                    .post("register", {
                        account: this.formData.account,
                        area_code: this.formData.code,
                        code: this.formData.vCode,
                        password: this.formData.password,
                        first_name: this.formData.firstName,
                        last_name: this.formData.lastName, //默认使用帐号填充姓名
                        register_type: 2
                    })
                    .then(({ data }) => {
                        //埋点
                        signupGtag({
                            姓名:
                                this.formData.firstName +
                                "/" +
                                this.formData.lastName,
                            "邮箱/手机": this.formData.account,
                            用户ID: data.data.user_id || ""
                        });
                        if (data.code === "2000") {
                            //修改登录状态
                            this.$store.dispatch(
                                "updateToken",
                                data.data.token
                            );

                            this.$store.dispatch("updateUser", data.data);
                            this.$store.dispatch(
                                "updateAvatar",
                                data.data.user_info.extend.avatar
                            );

                            //关闭当前页面
                            this.$store.dispatch("toggleShowSignup", false);

                            this.resetFields();
                        } else {
                            this.$msg.error(data.msg);
                        }
                    });
            });
        },
        toggleShowPasswd(form) {
            if (form.type === "password") {
                form.type = "text";
            } else {
                form.type = "password";
            }
        },
        resetFields() {
            this.$refs["formRef"].resetFields();
        },
        termsUse() {
            this.$store.dispatch("toggleShowSignup", false);
            this.$router.push({ name: "Conditions" });
        },
        policy() {
            this.$store.dispatch("toggleShowSignup", false);
            this.$router.push({ name: "Policy" });
        }
    }
};
</script>

<style lang="scss">
.sign-up-container .el-select .el-input {
    width: 100px;
}
.sign-up-container .el-input-group__prepend {
    background-color: #fff;
}
.sign-up-container .el-input-group__append {
    padding: 0;
    width: auto;
}
</style>

<style scoped>
.send-btn {
    height: 39px;
    width: 100%;
    appearance: none;
    background-color: transparent;
    color: #c5c5c5;
    cursor: not-allowed;
}
.send-btn-active {
    background-color: #00a9ba;
    color: #fff;
    cursor: pointer;
}
.mobile-btn {
    margin: 30px 0;
}
</style>



// WEBPACK FOOTER //
// src/views/Public/SignUp/Mobile.vue